import React from 'react';

const CaretDown = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="icons/caret--down" fill="currentColor">
                <polygon id="caret" points="17 10 12 15 7 10"></polygon>
            </g>
        </g>
    </svg>
);

export default CaretDown;
